/**
 * Ninja Forms scrolls `html, body` to reveal the success message after a
 * successful submit, even when the form is rendered inside a modal. Since
 * the modal already shows the message, that scroll just moves the page
 * behind the modal — restore the scroll position it had right before Ninja
 * Forms' own scroll animation (300ms) has had a chance to run.
 */
$( document ).on( 'nfFormSubmitResponse', function( event, response ) {
	const formId = response.id;

	if ( formId === undefined ) {
		return;
	}

	const $formCont = $( '#nf-form-' + formId + '-cont' );

	if ( !$formCont.length || !$formCont.closest( '.modal' ).length ) {
		return;
	}

	const scrollTop = $( window ).scrollTop();

	setTimeout( function() {
		$( 'html, body' ).stop( true ).scrollTop( scrollTop );
	}, 400 );
} );
